import { tags } from '../../projects/constants';

const { pt } = tags;

const projectsPagePt = {
  "trabalho-justo-para-mulheres": {
    title: "Trabalho Justo Para Mulheres",
    introduction: `<p>A Utópika é formada por mulheres que constroem soluções criativas a partir de contextos desafiadores. Essa perspectiva orienta a forma como nos envolvemos com projetos que dialogam com território, autonomia e justiça social.</p>
    <p>No Trabalho Justo para Mulheres, em parceria com a <a class="text-link" href="https://fase.org.br/pt/" target="_blank" rel="noreferrer">ONG FASE</a>, realizamos uma formação com mulheres que já tocam iniciativas produtivas em suas comunidades, sustentam suas famílias e movimentam economias locais.</p>
    <p>Como desdobramento, desenvolvemos o Caderno Mão na Massa e o Passaporte Bora de Maré, materiais pensados para apoiar e fortalecer essas iniciativas. Mais do que os produtos finais, o projeto consolidou um processo de construção coletiva, com escuta, troca e articulação de estratégias que reforçam redes e evidenciam a potência do que nasce do território.</p>`,
    credits: {
      title: "Créditos",
      info: [
        {
          role: "Formação e coordenação criativa",
          name: "Rachel Gepp e Julia Lima",
        },
        {
          role: "Diagramação",
          name: "Rachel Gepp e Julia Lima",
        },
        {
          role: "Ilustrações",
          name: "Julia Lima",
        },
        {
          role: "Assistente de arte",
          name: "Mariana Simões",
        },
      ]
    },
    tags: [pt.WORK, pt.WOMEN, pt.HUMAN_RIGHTS, pt.PUBLICATION, pt.ILLUSTRATION],
  },
  mongabay: {
    title: "Pacote Gráfico Mongabay",
    introduction: "O Mongabay é um portal de notícias ambientais com sede em diferentes regiões e precisava padronizar sua comunicação e facilitar a vida de editores que colaboram ao redor do mundo. Para isso criamos novos layouts para o seu pacote gráfico em vídeo com o intuito de ser versátil e se adequar ao consumo nas redes, sem perder a identidade do Mongabay.",
    paragraph1: "Fizemos então um pacote de essential graphics que pode facilmente ser usado no Adobe Premiere através de uma interface simples e com algumas opções de customização para o editor.",
    paragraph2: "Os gráficos são automatizados para se adaptar ao conteúdo. Códigos de programação controlam o tamanho das caixas de texto, quantidade de linhas e etc, fazendo com que o editor mexa no mínimo de propriedades possível.",
    paragraph3: "Fizemos versões verticais e horizontais de forma que as informações se comportassem de forma semelhante em ambos os formatos sem precisar de adaptações das editorias. Foi uma grande parceria com a coordenadora de vídeo do Mongabay, Lucia Torres, para que o pacote gráfico tivesse o melhor aproveitamento internamente.",
    credits: {
      title: "Créditos",
      info: [
        {
          role: "Coordenação e motion design",
          name: "Julia Lima",
        },
        {
          role: "Essential graphics",
          name: "Carla Dutra",
        },
        {
          role: "Automação",
          name: "Felipe Fernandes",
        },
        {
          role: "Estagiária",
          name: "Ana Clara Lury",
        },
      ]
    },
    tags: ['animação', 'meioAmbiente'],
  },
  plenamata: {
    title: "Plenamata",
    introduction: `O Plenamata é um portal com dados e notícias em tempo real sobre o desmatamento da Amazônia. Viabilizado pela Natura junto ao MapBiomas e o InfoAmazonia ele reúne indicadores, análises, além de dar visibilidade para iniciativas de conservação e regeneração da Amazônia.
    Ficamos muito felizes de participar um pouquinho dessa iniciativa com ilustrações, gifs e infográficos para o glossário do site.`,
    credits: {
      title: "Créditos",
      info: [
        {
          role: "Direção de Arte e ilustrações",
          name: "Julia Lima",
        },
        {
          role: "Assistente de design e animação",
          name: "Carla Dutra",
        },
        {
          role: "Estagiária",
          name: "Ana Clara Lury",
        },
      ]
    },
    tags: [pt.INFOGRAPHIC, pt.ILLUSTRATION, pt.ENVIRONMENT],
  },
  refarm: {
    title: "Refarm",
    introduction: `Projeto delícia para falar sobre peças bonitas da Farm em duas versões, malhas e jeans. A marca tem um posicionamento de algum tempo em várias frentes para alcançar a marca de #carbonozero e as animações elencam algumas ações específicas de ESG, divulgando práticas conscientes e socialmente conscientes :)`,
    credits: {
      title: "Créditos",
      info: [
        {
          role: "Ilustrações e animação",
          name: "Julia Lima",
        },
        {
          role: "Trilha",
          name: '"Adoro" - Flor de Sal',
        },
        {
          role: "Locução",
          name: "Karina Zevian",
        },
      ]
    },
    tags: ['animação', 'ilustração', 'esg', 'meioAmbiente'],
  },
  pasto: {
    title: "Do Prato ao Pasto",
    introduction: `O aplicativo do prato ao pasto da Trase ajuda o consumidor a identificar de onde vem a carne que compra no mercado e seu impacto ambiental escaneando o código de barra. Fizemos essa animação para a divulgação da 1a versão do app.

    Mais uma parceria com o super diretor Márcio Isensee.`,
    credits: {
      title: "Créditos",
      info: [
        {
          role: "Produção e finalização",
          name: '"Márcio Isensee',
        },
        {
          role: "Ilustrações e animação",
          name: "Julia Lima",
        },
      ]
    },
    tags: ['animação', 'ilustração', 'meioAmbiente'],
  },
  direitos: {
    title: "Direitos Humanos no Trabalho Rural",
    introduction: `Essa cartilha sobre direitos humanos no trabalho rural é fruto da pesquisa da Ana Cristina Nobre da consultoria Ambiente Social. Este é o primeiro de 6 temas, e serve como material de apoio para facilitadores sistematizarem temas complexos. O apoio visual é muito importante no trabalho de campo e ajuda na aproximação das pessoas com o assunto.`,
    credits: {
      title: "Créditos",
      info: [
        {
          role: "Diagramação e ilustração",
          name: 'Carla Dutra',
        },
        {
          role: "Direção de arte",
          name: "Julia Lima",
        },
      ]
    },
    tags: ['publicação', 'ilustração', 'infográfico', 'direitosHumanos', 'trabalho'],
  },
  rhino: {
    title: "Rhino Poops",
    introduction: `O Rinoceronte-de-Sumatra é uma espécie em extinção monitorada de perto. Mas para não perturbar os animais, os cientistas desenvolveram um método eficaz de acompanhar as famílias e preservar a espécie. Animação divertida para o Mongabay. Muito bom poder falar de coisas positivas que estão dando certo.`,
    credits: {
      title: "Créditos",
      info: [
        {
          role: "Ilustrações e animação",
          name: "Julia Lima",
        },
        {
          role: "Script e locução",
          name: "Manon Verchot",
        },
        {
          role: "Editorial",
          name: "Isabel Esterman, Basten Gokkon e Lucia Torres",
        },
      ]
    },
    tags: ['animação', 'ilustração', 'meioAmbiente'],
  },
  vozes: {
    title: "Vozes Femininas",
    introduction: `O livro escrito por Tatiane Matheus contou com a voz de 21 mulheres de diferentes lugares e saberes sobre diagnósticos e soluções para a crise climática. Nas palavras da autora “É um manifesto da transição justa na teoria e, sobretudo, na prática. Uma convocação do pensar global ao agir local. Qual a sua prontidão para, de fato, ouvir?”. Trabalhando junto ao GT de genero do <a class="text-link" href="https: //www.oc.eco.br/" target="_blank">Observatório do Clima</a> fica claro que qualquer recuperação possível coloca as mulheres no centro da solução. Vamos juntas :) `,
    credits: {
      title: "Créditos",
      info: [
        {
          role: "Projeto gráfico e direção de arte",
          name: "Julia Lima",
        },
        {
          role: "Ilustração e diagramação",
          name: "Ana Clara Lury",
        },
      ]
    },
    tags: ['mulheres', 'publicação', 'ilustração', 'igualdade'],
  },
  olhar: {
    title: "Olhar Perto, Enxergar Longe",
    introduction: `O livro "Olhar perto, enxergar longe: crônicas ambientais atemporais" é uma coletânea produzida pelo <a class="text-link" href="https://oeco.org.br/" target="_blank">O Eco</a> e organizada pelo jornalista Lorenzo Aldé com as crônicas do jornalista e fotógrafo Marcos Sá Corrêa. O livro reúne 98 colunas sobre os mais variados temas ambientais e as observações de Marcos Sá seguem surpreendentemente atuais, vale a leitura :)`,
    credits: {
      title: "Créditos",
      info: [
        {
          role: "Diagramação e projeto gráfico",
          name: "Laura Levín e Julia Lima",
        },
        {
          role: "Capa",
          name: "Carla Dutra",
        },
      ]
    },
    tags: ['meioAmbiente', 'publicação'],
  },
  guia: {
    title: "Um Guia para os Perplexos",
    introduction: `Elaborado pela <a class="text-link" href="https://laclima.org/" target="_blank">LACLIMA</a> e pelo <a class="text-link" href="https://www.oc.eco.br/" target="_blank">Observatório do Clima</a> o guia dos perplexos explica de forma didática e bem humorada explica tudo que você precisa saber sobre o Acordo de Paris e o funcionamento das COPs do clima da ONU. Por aqui fizemos o projeto gráfico e diagramação, pontuando o texto com algumas colagens. Um material muito rico e fácil de ler para qualquer pessoa que queira entender como caminha essa negociação, que por sua vez não é nada fácil.`,
    credits: {
      title: "Créditos",
      info: [
        {
          role: "Diagramação e projeto gráfico",
          name: "Rachel Gepp e Julia Lima",
        },
      ]
    },
    tags: ['publicação', 'ilustração', 'meioAmbiente'],
  },
  sitawi: {
    title: "Sitawi",
    introduction: `A Sitawi é uma organização que mobiliza recursos para projetos de impacto positivo. Esse foi um vídeo explicativo divertido de fazer. Mais uma parceria feliz com a <a class="text-link" href="http://cadenzafilmes.com.br/" target="_blank">Cadenza</a>.`,
    credits: {
      title: "Créditos",
      info: [
        {
          role: "Direção e produção",
          name: "Cadenza Filmes",
        },
        {
          role: "Roteiro",
          name: "Filipe Tomassini",
        },
        {
          role: "Layout e animação",
          name: "Julia Lima",
        },
      ]
    },
    tags: ['ilustração', 'igualdade', 'animação', 'meioAmbiente'],
  },
  mata: {
    title: "Mata Atlântica: Novas Histórias",
    introduction: `Esse <a class="text-link" href="https://oeco.org.br/especial/mataatlantica/" target="_blank">especial sobre Mata Atlântica</a> publicado no ((o)) eco, em parceria com o Instituto Serrapilheira, contou com 10 reportagens e 10 artigos falando sobre ações de restauração da Mata Atlântica, nosso bioma mais desmatado.

    Além da identidade visual, ilustrações e infográficos, o projeto foi desdobrado em um <a class="text-link" href="https://oeco.org.br/biblioteca/mata-atlantica-novas-historias/" target="_blank">ebook</a> com todas as reportagens, <a class="text-link" href="https://oeco.org.br/biblioteca/biodiversidade-em-pauta-um-guia-para-comunicadores-ebook/" target="_blank">um guia para comunicadores</a> com material sobre biodiversidade de todos os biomas e ainda um seminário online sobre o tema.`,
    credits: {
      title: "Créditos",
      info: [
        {
          role: "Identidade Visual, ilustrações e projeto gráfico",
          name: "Julia Lima",
        },
        {
          role: "Assistente de design",
          name: "Carla Dutra",
        },
        {
          role: "Estagiária",
          name: "Ana Clara Lury",
        },
      ]
    },
    tags: ['animação', 'ilustração', 'território', 'meioAmbiente', 'infográfico'],
  },
  vozesin: {
    title: "Vozes Indígenas",
    introduction: `Projeto de animação para a campanha dos Guardiões do Iriri, do Povo Arara. Uma iniciativa da parceria do <a class="text-link" href="https://en.institutomaira.org/" target="_blank">Instituto Maíra</a> e <a class="text-link" href="https://anistia.org.br/" target="_blank">Anistia Internacional</a>, que apoiam a resistência histórica e luta dos Arara pela garantia de seus direitos territoriais e a urgência global pela preservação do meio ambiente.
    Nosso trabalho passa pela compreensão aprofundada da luta socio ambiental, o que nos possibilita uma criação de roteiro e construção de imagens que toquem na realidade, com sensibilidade e respeito a cada tema.`,
    credits: {
      title: "Créditos",
      info: [
        {
          role: "Roteiro, ilustração e direção criativa",
          name: "Rachel Gepp",
        },
        {
          role: "Locução",
          name: "Carla Marques e Solaira Studios",
        },
        {
          role: "Animação",
          name: "Julia Lima",
        },
        {
          role: "Sonorização",
          name: "Rodrigo Chuva",
        },
      ]
    },
    tags: ['animação', 'ilustração', 'território', 'meioAmbiente', 'direitosHumanos'],
  },
  plastico: {
    title: "Sem Plástico",
    introduction: `Esse vídeo explicativo foi realizado em 2019 em parceria com a produtora Cadenza. Aqui fizemos as ilustrações e animação dessa iniciativa do WWF junto ao Banco do Brasil para a redução do consumo de plásticos.
    `,
    credits: {
      title: "Créditos",
      info: [
        {
          role: "Produção",
          name: "Cadenza",
        },
        {
          role: "Direção de Arte",
          name: "Julia Lima",
        },
        {
          role: "Ilustrações",
          name: "Rachel Gepp",
        },
        {
          role: "Animação",
          name: "Marcelo Antônio e Julia Lima",
        },
      ]
    },
    tags: ['animação', 'ilustração', 'meioAmbiente', 'esg'],
  },
  captura: {
    title: "Captura Corporativa",
    introduction: `Em tempos de ameaça às nossas instituições, aproveitamos para lembrar desta animação feita em parceria com a <a class="text-link" href="https://www.escr-net.org/" target="_blank">ESCR-Net</a>. Uma iniciativa da comunidade de direitos humanos para chamar atenção para a prática da "captura corporativa", esta tendência das empresas de tomarem conta das nossas instituições democráticas duramente conquistadas.
    `,
    credits: {
      title: "Créditos",
      info: [
        {
          role: "Direção de arte e ilustrações",
          name: "Rachel Gepp",
        },
        {
          role: "Animação",
          name: "Julia Lima",
        },
      ]
    },
    tags: ['ilustração', 'animação', 'meioAmbiente', 'direitosHumanos', 'política'],
  },
  despolarize: {
    title: "Despolarize",
    introduction: `Esse projeto foi feito no auge da polarização, logo antes da pandemia. Fizemos essa animação para a ong <a class="text-link" href="https://www.politize.com.br/" target="_blank">Politize!</a> que trabalha com educação política em prol da democracia O vídeo divulga o material criado por eles para enfrentar essa questão e criar pontes de diálogo em um cenário de muitos rachas entre famílias e amigos.
    `,
    credits: {
      title: "Créditos",
      info: [
        {
          role: "Ilustrações e animação",
          name: "Julia Lima",
        },
        {
          role: "Roteiro, locução e produção",
          name: "Danila Bustamante e Felipe Maia",
        },
        {
          role: "Sonorização",
          name: "Manon Ribat",
        },
      ]
    },
    tags: ['ilustração', 'animação', 'política'],
  },
  alianza: {
    title: "Alianza",
    introduction: `Depois de um ano de atuação, a <a class="text-link" href="https://alianzafondosdelsur.org/" target="_blank">Alianza</a>, que reúne fundos locais de diversos países do sul Global, publicou seu primeiro relatório inaugurando sua comunicação! Para potencializar sua estratégia de comunicação, criamos também um site para a instituição postar notícias, relatórios e dados além de um folder informativo para eventos. Agregamos à identidade da Alianza a diversidade humana e dos biomas onde eles atuam. <a class="text-link" href="https://alianzafondosdelsur.org/" target="_blank">www.alianzafondosdelsur.org</a>`,
    credits: {
      title: "Créditos",
      info: [
        {
          role: "Diagramação e projeto gráfico",
          name: "Rachel Gepp e Julia Lima",
        },
        {
          role: "Desenvolvimento web",
          name: "Felipe Fernandes",
        },
        {
          role: "Assistência de Design",
          name: "Ana Clara Lury",
        },
      ]
    },
    tags: ['ilustração', 'infográfico', 'mídiasSociais', 'publicação', 'território', 'meioAmbiente', 'direitosHumanos', 'igualdade', 'web'],
  },
  clima: {
    title: "Em Nome do Clima - Mapeamento Crítico",
    introduction: `<p>O objetivo desta pesquisa era compreender e dar visibilidade às estratégias adotadas pelos governos e por empresas neoextrativistas (complexo hidro-agro-energético-mineral) ante a crise climática e às implicações dos usos que fazem das categorias transição energética, energia renovável, descarbonização e compensação.</p>
    <p>O papel da Utópika foi traduzir esses dados complexos e discursos obtusos das estratégias governamentais e empresariais em um design acessível e compreensível. Trabalhamos para tornar essas informações claras e impactantes, facilitando o entendimento e o engajamento da sociedade civil.</p>
    <p>Para a divulgação do estudo, produzimos uma websérie com cinco animações, relatórios, infográficos e cards para as redes sociais, facilitando o acesso a essas informações vitais para que mais pessoas possam compreender e agir sobre elas.</p>`,
    credits: {
      title: "Créditos",
      info: [
        {
          role: "Projeto gráfico e ilustrações",
          name: "Rachel Gepp e Julia Lima",
        },
        {
          role: "Assistência de Design",
          name: "Beatriz Fukumoto",
        },
      ]
    },
    tags: ['publicação', 'ilustração', 'infográfico', 'território', 'meioAmbiente', 'direitosHumanos'],
  },
  forest: {
    title: "Forest Ventures",
    introduction: `Essa série de podcast olha para a floresta pelo ângulo dos negócios e mostra que a floresta em pé está na base de uma série de iniciativas que envolvem compromisso ambiental e social. Para construir essa identidade visual partimos de elementos comuns ao mundo dos investimentos, como os gráficos, e também da natureza, como as folhas, e as curvas dos rios que também aparecem nas ondas sonoras.`,
    credits: {
      title: "Créditos",
      info: [
        {
          role: "Projeto gráfico",
          name: "Julia Lima",
        },
        {
          role: "Assistente de design e Ilustrações",
          name: "Ana Clara Lury",
        },
      ]
    },
    tags: [pt.SOCIAL_MEDIA, pt.VISUAL_IDENTITY, pt.ILLUSTRATION, pt.ENVIRONMENT],
  },
  populacao: {
    title: "População LGBTI+ Privada de Liberdade no Brasil",
    introduction: `Tivemos o desafio de dar visibilidade às condições enfrentadas pelas pessoas LGBTI+ no sistema prisional brasileiro, utilizando arte para sensibilizar como informações críticas são percebidas e compreendidas. Nosso maior desafio foi ilustrar esse tema tão sensível e complexo de maneira que respeitasse a seriedade do assunto e ao mesmo tempo facilitasse o entendimento. Obrigada <a class="text-link" href="https://www.somos.org.br/" target="_blank">@somos</a>, <a class="text-link" href="https://www.apt.ch/pt" target="_blank">@apt</a> e <a class="text-link" href="https://mnpctbrasil.wordpress.com/" target="_blank">@mecanismo</a> pela confiança!`,
    credits: {
      title: "Créditos",
      info: [
        {
          role: "Projeto gráfico e ilustrações",
          name: "Rachel Gepp",
        },
      ]
    },
    tags: [pt.PUBLICATION, pt.ILLUSTRATION, pt.EQUALITY, pt.HUMAN_RIGHTS],
  },
  p4f: {
    title: "Partnerships for Forests",
    introduction: `<p>O Partnerships for forests é um programa do governo britânico que impulsiona negócios florestais e o que ele precisa para ser viabilizado. Difícil resumir aqui um atendimento de 4 anos e tantos aprendizados, a verdade é que vimos o assunto ganhar corpo durante esse tempo.</p>
    <p>De 2020 a 2024 Foram mais de 30 estudos de caso, portfólios, guias, animações entre outras muitas entregas para o braço da América Latina. Passaram muitos projetos interessantes por lá, e por consequência, por aqui também. Somos só agradecimento pelo time interno e externo que fez tanta coisa bacana acontecer.</p>`,
    credits: {
      title: "Créditos",
      info: [
        {
          role: "Coordenação",
          name: "Julia Lima",
        },
        {
          role: "Animação e Projetos Gráficos",
          name: "Julia Lima",
        },
        {
          role: "Designers",
          name: "Carla Dutra, Laura Levín, Ana Clara Lury, Ana Clara Abbate e Beatriz Fukumoto",
        },
      ]
    },
    tags: [pt.PUBLICATION, pt.ANIMATION, pt.ENVIRONMENT, pt.INFOGRAPHIC, pt.SOCIAL_MEDIA],
  },
  facanhas: {
    title: "Façanhas do Homem na Floresta",
    introduction: `<p>Tivemos o prazer de abraçar o ICMBio e fazer o projeto gráfico e diagramação do  livro “Façanhas do Homem na Floresta - memórias de 30 anos de conservação da biodiversidade”, que homenageia a trajetória do servidor Raimundo Façanha e seu caminho percorrido até chegar ao IBAMA.</p>
    <p> A história da conservação da biodiversidade nos últimos 30 anos na região de Carajás se confunde com o testemunho vivo do Façanha.</p>
    <p> Numa narrativa recheada de causos e memórias vibrantes, o livro  permite uma análise sobre a dinâmica territorial e as transformações sociais da região.</p>`,
    credits: {
      title: "Créditos",
      info: [
        {
          role: "Diagramação e Projetos Gráficos",
          name: "Rachel Gepp",
        },
        {
          role: "Assistência de Design",
          name: "Ana Clara Lury",
        },
      ]
    },
    tags: [pt.ILLUSTRATION, pt.PUBLICATION, pt.ENVIRONMENT, pt.INFOGRAPHIC, pt.TERRITORY],
  },
  solidaria: {
    title: "Economia Solidária Digital",
    introduction: `<p>Para nós da Utópika, participar desse projeto foi uma oportunidade de reafirmar nossos valores: o design como uma ferramenta poderosa de transformação social. Nosso trabalho vai além da criação visual; buscamos facilitar a compreensão de temas complexos e gerar engajamento, conectando as pessoas com questões importantes para o seu futuro.</p>
    <p> É uma honra para nós não só participar da criação de narrativas que promovam justiça social de forma honesta e transparente, mas também sermos consideradas uma voz nesse processo.</p>
    <p>Explorem o livro e se envolvam na construção do futuro do trabalho e dessa nova economia!</p>
    <p>Obrigada por tanto <a class="text-link" href="https://www.instagram.com/danielsantini/" target="_blank">@danielsantini</a> e <a class="text-link" href="https://www.instagram.com/grohmannrafael/" target="_blank">@grohmannrafael</a> e <a class="text-link" href="https://rosalux.org.br/" target="_blank">Fundação Rosaluxemburgo</a></p>
    `,
    credits: {
      title: "Créditos",
      info: [
        {
          role: "Projeto gráfico e ilustrações",
          name: "Rachel Gepp",
        },
        {
          role: "Assistência de Design",
          name: "Ana Clara Abbate",
        },
        {
          role: "Vídeo Lançamento",
          name: "Diego da Silveira",
        },
      ]
    },
    tags: [pt.PUBLICATION, pt.EQUALITY, pt.POLITICS, pt.HUMAN_RIGHTS, pt.WORK, pt.SOCIAL_MEDIA],
  },
  agricultura: {
    title: "Agricultura Familiar e Clima",
    introduction: `<p>Com muito entusiamo lançamos esta campanha junto com a <a class="text-link" href="https://www.instagram.com/contag_brasil/" target="_blank">@contag_brasil</a> e o <a class="text-link" href="https://www.instagram.com/observatoriodoclima/" target="_blank">@observatoriodoclima</a>, contruindo um material para as formações com os agricultores familiares sobre clima. Aprendemos um tanto! Mais um capítulo importantíssimo para falar de justiça climática, já que a agricultura familiar é essencial para a segurança alimentar e, será a mais afetada pelos eventos extremos.</p>
    <p>Este projeto também foi muito especial por ter possibilitado agregar parcerias antigas e novas, na identidade visual tivemos a colaboração da <a class="text-link" href="https://www.instagram.com/lalaulevin/" target="_blank">@lalaulevin</a>, o podcast nos trouxe a parceria com a querida <a class="text-link" href="https://www.instagram.com/georgiapsantos/" target="_blank">@georgiapsantos</a> <a class="text-link" href="https://www.instagram.com/todavos/" target="_blank">@todavos</a>, no site nosso parceiro de caminhada
    <a class="text-link" href="https://www.instagram.com/felipedfe/" target="_blank">@felipedfe</a>, também tivemos cartilha, animação e ainda tem material para sair!</p>
    `,
    credits: {
      title: "Créditos",
      info: [
        {
          role: "Projeto gráfico e ilustrações",
          name: "Julia Lima e Rachel Gepp",
        },
        {
          role: "Identidade Visual",
          name: "Julia Lima e Laura Levin",
        },
        {
          role: "Animação",
          name: "Julia Lima",
        },
        {
          role: "Locução",
          name: "Raul Zoche",
        },
        {
          role: "Assistência de Design",
          name: "Beatrik Fukumoto",
        },
        {
          role: "Edição podcast",
          name: "Todavos",
        },
      ]
    },
    tags: [pt.ILLUSTRATION, pt.WEB, pt.ENVIRONMENT, pt.PUBLICATION, pt.ANIMATION, pt.SOCIAL_MEDIA, pt.VISUAL_IDENTITY, pt.WORK],
  },
  "mare-de-ciencia": {
    title: "Maré de Ciência",
    introduction: `<p>Desenvolvemos um projeto especial para <a class="text-link" href="https://oeco.org.br/" target="_blank">O Eco</a> e <a class="text-link" href="https://maredeciencia.eco.br/" target="_blank">Maré de Ciência</a>: uma cartilha que conecta escolas à cultura oceânica, incentivando crianças a explorar e compreender a importância do oceano para o futuro do planeta.</p>
    <p>Trabalhar com educação ambiental é sempre uma experiência enriquecedora. Neste projeto, criamos imagens que não apenas comunicam, mas também engajam os estudantes, inspirando-os a se tornarem agentes de um mundo mais sustentável. Afinal, o oceano é um patrimônio de todos nós!</p>
    `,
    credits: {
      title: "Créditos",
      info: [
        {
          role: "Diagramação e projeto gráfico",
          name: "Rachel Gepp",
        },
      ]
    },
    tags: [pt.PUBLICATION, pt.ILLUSTRATION, pt.ENVIRONMENT],
  },
  alziras: {
    title: "Alziras - Violência Política",
    introduction: `<p>Durante o período eleitoral, em parceria com o <a class="text-link" href="https://alziras.org.br/" target="_blank">Instituto Alziras</a>, desenvolvemos um conjunto de ferramentas para monitoramento e enfrentamento da violência política de gênero. Nesta entrega, produzimos uma publicação robusta, <a class="text-link" href="https://alziras.org.br/violenciapolitica/" target="_blank">um site acessível</a> e materiais informativos para incidência no período eleitoral, reunindo dados, estratégias de enfrentamento e suporte para vítimas.</p>
    <p>Nosso papel foi transformar esse tema urgente em um design acessível e informativo, criando recursos visuais que ampliam a conscientização e fortalecem o combate a essa forma de violência, garantindo que mais mulheres possam ocupar espaços políticos sem medo ou silenciamento.</p>`,
    credits: {
      title: "Créditos",
      info: [
        {
          role: "Diagramação e projeto gráfico",
          name: "Rachel Gepp",
        },
        {
          role: "Assistência de Design",
          name: "Ana Clara Abbate",
        }
      ]
    },
    tags: [pt.PUBLICATION, pt.INFOGRAPHIC, pt.WEB],
  },
  revolusolar: {
    title: "Revolusolar",
    introduction: `<p>A Revolusolar é uma organização comprometida em democratizar o acesso à energia solar em comunidades de baixa renda. Mais do que a instalação de painéis solares, seu trabalho envolve a capacitação de moradores, a geração de empregos locais e a promoção da educação ambiental. Tivemos o prazer de contribuir para esse projeto, tornando o conteúdo mais acessível e inspirador por meio do design.</p>
    <p>Desejamos sucesso aos novos amigos da <a class="text-link" href="https://www.instagram.com/revolusolar/" target="_blank">@revolusolar</a> nessa iniciativa transformadora, que impacta vidas e constrói um futuro mais sustentável.</p>`,
    credits: {
      title: "Créditos",
      info: [
        {
          role: "Diagramação e projeto gráfico",
          name: "Rachel Gepp",
        },
        {
          role: "Assistência de Design",
          name: "Ana Clara Abbate",
        }
      ]
    },
    tags: [pt.PUBLICATION, pt.ILLUSTRATION, pt.EQUALITY],
  },
  mobilizacao: {
    title: "Mobilização dos Povos Pela Terra e Pelo Clima",
    introduction: `<p>A parceria entre a Utopika e a Amana Comunicação é uma união de propósitos pela transformação social. Em sintonia com a COP30, desenvolvemos a identidade visual da mobilização promovida pela <a class="text-link" href="https://repam.org.br/" target="_blank">Rede Eclesial Pan-Amazônica (REPAM-Brasil)</a>, conectando o colorido da Amazônia com a força da juventude e a diversidade dos povos.</p>
    <p>Nossa colaboração evidencia como equipes podem, juntas, potencializar o impacto de cada projeto, traduzindo valores em narrativas visuais que inspiram e mobilizam.</p>`,
    credits: {
      title: "Créditos",
      info: [
        {
          role: "Diagramação e projeto gráfico",
          name: "Rachel Gepp",
        },
      ]
    },
    tags: [pt.SOCIAL_MEDIA, pt.ILLUSTRATION, pt.VISUAL_IDENTITY, pt.TERRITORY, pt.ENVIRONMENT],
  },
  "funding-the-planets-guardians": {
    title: "Funding The Planets Guardians",
    introduction: `<p>No centro da pauta climática global, o financiamento para ações socioambientais é um dos maiores desafios. O jogo Funding the Planet’s Guardians, criado em parceria com a <a class="text-link" href="https://alianzafondosdelsur.org/" target="_blank">Alianza Fondos del Sur</a>, conseguiu traduzir essa complexidade em uma dinâmica acessível e instigante, onde os participantes enfrentam dilemas reais sobre alocação de recursos e o impacto direto nas comunidades vulneráveis.</p>
    <p>Acreditamos que a gamificação é uma poderosa ferramenta para sensibilizar e engajar públicos diversos, ajudando organizações a comunicar temas complexos com mais impacto!</p>
    <p>Obrigada <strong>Juliana Tinoco</strong>, <strong>Clara Daré</strong> e <strong>Vitor Paiva</strong> pela parceria! É uma alegria compartilhar este prêmio com vcs!</p>
    `,
    credits: {
      title: "Créditos",
      info: [
        {
          role: "Projeto gráfico",
          name: "Julia Lima e Rachel Gepp",
        },
        {
          role: "Ilustrações",
          name: "Rachel Gepp",
        },
        {
          role: "Produção",
          name: "Julia Lima e Rachel Gepp",
        },
        {
          role: "Roteiro",
          name: "Vitor Paiva, Clara Daré e Juliana Tinoco",
        },
      ]
    },
    tags: [pt.ILLUSTRATION, pt.TERRITORY, pt.ENVIRONMENT, pt.VISUAL_IDENTITY, pt.HUMAN_RIGHTS],
  },
    promar: {
    title: "Promar",
    introduction: `<p>A comunicação visual é uma estratégia essencial para tornar a ciência acessível e ampliar seu impacto. Foi com essa visão que criamos a identidade visual do PROMAR, um programa da universidade dedicado a mapear e proteger as áreas marinhas no estado de São Paulo, com objetivo de pautar políticas públicas em diálogo com a população local.</p>
    <p>Inspirada no espírito exploratório e científico do projeto, a identidade visual do PROMAR traduz descoberta, mapeamento e inovação, unindo elementos gráficos que remetem à revelação de camadas ocultas no fundo do oceano.</p>`,
    credits: {
      title: "Créditos",
      info: [
        {
          role: "Designer",
          name: "Ana Clara Abbate",
        },
        {
          role: "Direção criativa",
          name: "Rachel Gepp e Julia Lima",
        },
      ]
    },
    tags: [pt.VISUAL_IDENTITY,  pt.ENVIRONMENT],
  },
    seminario: {
    title: "Seminário Sobre Dados de Raça, Gênero e Clima",
    introduction: `<p>A Utópika teve a honra de criar a identidade visual desse encontro. Mais do que peças de design, construímos um espaço visual onde os saberes puderam se fortalecer e se espalhar.</p>
    <p>O Seminário Raça, Gênero e Clima, foi uma iniciativa do <a class="text-link" href="https://www.oc.eco.br/" target="_blank">Observatório do Clima</a>, <a class="text-link" href="https://www.instagram.com/ipeaoficial/" target="_blank">ipea</a> e <a class="text-link" href="https://www.geledes.org.br/" target="_blank">Portal Geledés</a> onde dados, territórios e experiências se cruzaram com afeto, escuta e estratégia. E tudo isso só foi possível porque trabalhamos lado a lado com a potência da <a class="text-link" href="https://entremeios.me/" target="_blank">Entremeios</a> que é beleza e inteligência em cada detalhe. Seguimos acreditando que o futuro será feito por mãos femininas.</p>`,
    credits: {
      title: "Créditos",
      info: [
        {
          role: "Direção criativa",
          name: "Julia Lima",
        },
        {
          role: "Assistente de design",
          name: "Ana Clara Abbate",
        },
      ]
    },
    tags: [pt.VISUAL_IDENTITY, pt.PUBLICATION, pt.WOMEN, pt.ENVIRONMENT],
  },
}

export default projectsPagePt;

{/* 
  <a class="text-link" href="https://alziras.org.br/violenciapolitica/" target="_blank">um site acessível</a>
<a class="text-link" href="https://alziras.org.br/" target="_blank">Instituto Alziras</a>
<a class="text-link" href="https://alianzafondosdelsur.org/" target="_blank">Alianza Fondos del Sur</a>
<a class="text-link" href="https://www.instagram.com/revolusolar/" target="_blank">@revolusolar</a>
<a class="text-link" href="https://repam.org.br/" target="_blank">Rede Eclesial Pan-Amazônica (REPAM-Brasil)</a> 
<a class="text-link" href="https: //www.oc.eco.br/" target="_blank">Observatório do Clima</a>
*/}
